import { render } from "./ProfileActionHeader.vue?vue&type=template&id=3dab643a&scoped=true"
import script from "./ProfileActionHeader.vue?vue&type=script&lang=js"
export * from "./ProfileActionHeader.vue?vue&type=script&lang=js"

import "./ProfileActionHeader.vue?vue&type=style&index=0&id=3dab643a&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dab643a"]])

export default __exports__